/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-24T16:23:29.441
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveFinancialPayment,
	getFinancialPaymentCreateInit,
	getFinancialPaymentEditInit,
	getFinancialPaymentView,
	deleteFinancialPayment
} from '@api/financial/FinancialPayment';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

import {
listFinancialPaymentItemInit,
listFinancialPaymentItemByAuthorizations,
deleteFinancialPaymentItem
} from '@api/financial/FinancialPaymentItem';

export default {
	namespaced: true,

	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getFinancialPaymentCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getFinancialPaymentCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialPaymentEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialPaymentEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveFinancialPayment({}, FinancialPayment) {
			return new Promise((resolve, reject) => {
				saveFinancialPayment(FinancialPayment)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getFinancialPaymentView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getFinancialPaymentView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialPayment({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialPayment({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
